import React from 'react'
import { Navigate } from 'react-router'
import { useAppSelector } from '../hooks/reduxHooks'
import { selectUser } from '../redux/slices/UserSlice/UserSlice.selectors'

const PrivateRoute: ReactFC = ({ children }) => {
  const { token: userToken } = useAppSelector(selectUser)

  if (!userToken) {
    return <Navigate to='/login' />
  }

  return <>{children}</>
}

export default PrivateRoute
